import { useNavigate } from 'react-router-dom';

import lang from '../../lib/language';

import ImageWarning from '../../assets/img/error_not_found_image.svg';
import PortalLogo from '../../assets/img/portal_logo_carousel.svg';
import Button from '../../shared_components/Button/Button';
import { ButtonTypesEnum } from '../../shared_components/Button/Button.types';

import styles from './Error.module.scss';

const Error = () => {
  const navigate = useNavigate();
  const [firstPart, secondPart] = lang.requestErrorTryAgain().split('.', 2);

  return (
    <div className={styles.wrapper}>
      <div className={styles.container}>
        <div className={styles.logoWrapper}>
          <img src={PortalLogo} alt="logo" />
        </div>
        <div className={styles.errorImageWrapper}>
          <img className={styles.image} src={ImageWarning} alt="error" />
        </div>
        <div className={styles.textWrapper}>
          <span>
            {firstPart}
            .
          </span>
          <br />
          <span>
            {secondPart}
            {'.'}
          </span>
        </div>
        <Button
          fullWidth
          variant={ButtonTypesEnum.Primary}
          onClick={() => navigate(-1)}
        >
          {lang.commonGoBackBtn()}
        </Button>
      </div>
    </div>
  );
};
export default Error;
